<app-menu>
  <div class="desktop">
    <div class="header">
      <app-titulo text="Fornecedores"></app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Cadastrar fornecedor"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigateRegistrarDiario()"
        ></app-botao>
      </div>
    </div>
    <div class="table-header">
      <h1 class="table-title">Listagem</h1>
      <div class="table-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="this.pesquisaParams.TxPesquisar"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          type="date"
          placeholder="Data"
          [(ngModel)]="this.pesquisaParams.DtDiario"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
      </div>
    </div>
    <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
    <app-paginacao
      [pages]="pesquisaParams.MaxPages"
      (selectedPage)="mudarPagina($event)"
    ></app-paginacao>
  </div>

  <div class="mobile">
    <app-titulo text="Planejamento"></app-titulo>
    <div class="listagem">
      <div
        class="menu-mobile"
        (click)="this.expandirCardsMobile = !this.expandirCardsMobile"
      >
        <app-titulo class="title" text="Fornecedores"></app-titulo>
        <img
          *ngIf="!expandirCardsMobile"
          src="assets/images/arrow-down.svg"
          class="expandir-icon"
        />
        <img
          *ngIf="expandirCardsMobile"
          src="assets/images/arrow-up.svg"
          class="expandir-icon"
        />
      </div>
      <div class="mobile-filters">
        <app-input
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="this.pesquisaParams.TxPesquisar"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          type="date"
          placeholder="Data"
          [(ngModel)]="this.pesquisaParams.DtDiario"
          (ngModelChange)="onChangeSearch()"
          *ngIf="expandirCardsMobile"
        ></app-input>
        <app-botao
          type="primario"
          text="Cadastrar fornecedor"
          width="100%"
          icon="assets/images/add.svg"
          (click)="navigateRegistrarDiario()"
        ></app-botao>
      </div>
      <app-card-mobile
        [data]="tableData"
        [rows]="rowsMobile"
        [expand]="expandirCardsMobile"
      ></app-card-mobile>
      <app-paginacao
        [pages]="pesquisaParams.MaxPages"
        (selectedPage)="mudarPagina($event)"
      ></app-paginacao>
      <!-- <app-botao
        type="secundario"
        text="Exportar Excel"
        width="100%"
        icon="assets/images/download-icon.svg"
        (click)="exportExcel()"
      ></app-botao> -->
    </div>
  </div>
</app-menu>
<app-loader *ngIf="loader" />
